import { Badge } from '@connected/ui/components/badge';
import { Section } from '@connected/ui/features/layouts';
import { useTranslation } from 'react-i18next';

import { cn } from '@/lib/utils';

import type { ScopeSeverity } from '../../observation/utils/observation-severity-utils';
import type { ObservationLog } from '../utils/observation-log-types';

import { LabeledIndicator } from '../../observation/components/observation-severity-indicator';
import { OBSERVATION_COLOR_CODES } from '../../observation/utils/observation-constants';
import { getObservationLogIdentifier } from '../utils/observation-log-utils';
import { ObservationLogModal } from './observation-log-modal';

export type ObservationLogHeaderProps = {
    observationLog: ObservationLog;
    status?: 'Approved' | 'Rejected';
};

export function ObservationLogHeader({ observationLog, status }: ObservationLogHeaderProps) {
    const { t } = useTranslation('re-inspections');

    const severities: ScopeSeverity[] = observationLog.Reports?.filter(report => report.Enabled === true)?.map(report => ({
        inspectionKind: report.InspectionKind!,
        codeKind: report.CodeKind!,
        hexColor: OBSERVATION_COLOR_CODES[report.CodeKind!] || '#000000',
    })) || [];

    const identifier = getObservationLogIdentifier(observationLog);

    return (
        <Section.Header>
            <div className="flex flex-col">
                <div className="flex flex-row items-center gap-2">
                    <Section.Header.Title>
                        {identifier
                            ? (
                                    <>
                                        {identifier.identifier}
                                        {' '}
                                        -
                                        {' '}
                                        {t(`observations.objectKinds.${identifier.kind}`)}
                                    </>
                                )
                            : 'Constatering zonder object'}
                    </Section.Header.Title>
                </div>
                <div className="flex flex-row gap-2">
                    {
                        observationLog.LocationRemark && observationLog.LocationRemark.length > 0
                        && (
                            <>
                                <Section.Header.SubTitle>
                                    {observationLog.LocationRemark}
                                </Section.Header.SubTitle>
                                <Section.Header.SubTitle>
                                    {' • '}
                                </Section.Header.SubTitle>
                            </>
                        )
                    }
                    <Section.Header.SubTitle>
                        <LabeledIndicator severities={severities} />
                    </Section.Header.SubTitle>
                </div>
            </div>
            <Section.Header.Actions>
                {status
                    ? <ObservationLogHeaderBadge status={status} electricalProjectObservationId={observationLog.ElectricalProjectObservationId!} />
                    : (
                            <>
                                <ObservationLogModal observationLog={observationLog} status="Rejected" />
                                <ObservationLogModal observationLog={observationLog} status="Approved" />
                            </>
                        )}
            </Section.Header.Actions>
        </Section.Header>
    );
}

type ObservationLogHeaderBadgeProps = {
    status: 'Approved' | 'Rejected';
    electricalProjectObservationId: string;
};

function ObservationLogHeaderBadge({ status }: ObservationLogHeaderBadgeProps) {
    // const { context: { electricalProjectVersionId } } = useElectricalProject();

    // const mutation = useObservationLogStatusMutation({
    //     electricalProjectVersionId,
    // });

    // function handleSubmit() {
    //     mutation.mutate({
    //         body: {
    //             ElectricalProjectObservationId: electricalProjectObservationId,

    //         },
    //     });
    // }

    return (
        // <button type="submit" >
        <Badge variant={status === 'Rejected' ? 'failure' : 'success'} className="flex flex-row gap-2">
            <p className={cn('flex flex-row items-center gap-2', status === 'Rejected' ? 'text-failure-foreground' : 'text-success-foreground',
            )}
            >
                {status === 'Rejected' ? 'Afgekeurd' : 'Goedgekeurd'}
            </p>
            {/* <p>
                    X
                </p> */}
        </Badge>
        // </button>
    );
}
